import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import VitalManualEntryLayout from "../../components/Common/VitalManualEntryLayout";
import { SingleVitalInput } from "../../components/Common/VitalInput";

export interface HeartRateManualEntryProps {
  onBack?: () => void;
  onCancel?: () => void;
  onSave?: () => void;
}

export default function HeartRateManualEntry({
  onBack,
  onCancel,
  onSave,
}: HeartRateManualEntryProps = {}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [value, setValue] = useState("");

  const handleBack = onBack ?? (() => navigate(-1));
  const handleCancel = onCancel ?? (() => navigate(-1));

  const handleSave = () => {
    // TODO: Implement save functionality
    console.log("Saving heart rate:", value);
    if (onSave) onSave();
    else navigate(-1);
  };

  return (
    <VitalManualEntryLayout
      title={t("HeartRate.manualEntry.title")}
      onBack={handleBack}
      onCancel={handleCancel}
      onSave={handleSave}
      isSaveDisabled={!value}
      cancelText={t("HeartRate.manualEntry.cancel")}
      saveText={t("HeartRate.manualEntry.save")}
    >
      <SingleVitalInput
        value={value}
        onChange={setValue}
        placeholder="72"
        ariaLabel={t("HeartRate.manualEntry.inputLabel")}
        unit={t("HeartRate.unit")}
        max={250}
      />
    </VitalManualEntryLayout>
  );
}
